var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmployeePage',[_c('TrainingTable',{staticClass:"card",attrs:{"rows":_vm.rows,"loading":_vm.loading,"error":null}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }